export enum PermissionId {
  FEATURE_MATRIX_ACCESS = 'feature-matrix-access',
}

export type PermissionDto = {
  id?: string;
  name: string;
  hint?: string;
  clientAdminBlocked?: boolean;
  wbAdminBlocked?: boolean;
  children?: PermissionDto[];
};

export type PermissionModel = {
  id?: string;
  name?: string;
  hint?: string;
  isClientAdminBlocked?: boolean;
  isAdminBlocked?: boolean;
  children?: PermissionModel[];
};

export function mapPermissionModelToDto(model: PermissionModel): PermissionDto {
  return {
    id: model.id,
    name: model.name,
    children: model.children ? model.children.map(mapPermissionModelToDto) : [],
  };
}

export function mapPermissionDtoToModel(dto: PermissionDto): PermissionModel {
  return {
    id: dto.id,
    name: dto.name,
    hint: dto.hint,
    isClientAdminBlocked: dto.clientAdminBlocked,
    isAdminBlocked: dto.wbAdminBlocked,
    children: dto.children ? dto.children.map(mapPermissionDtoToModel) : [],
  };
}
